export const DEFAULT_INVOICE_DESIGN = {
  theme: 'modern', // 'modern' | 'classic' | 'minimal' | 'elegant' | 'grid' | 'compact'
  primaryColor: '#0ea5e9',
  secondaryColor: '#f8fafc',
  textColor: '#0f172a',
  fontFamily: 'Inter, sans-serif',
  density: 'normal', // 'compact' | 'normal' | 'spacious'
  borderRadius: 8,

  // Document Titles
  invoiceTitle: 'TAX INVOICE',
  quotationTitle: 'PRICE QUOTATION',
  proformaTitle: 'PROFORMA INVOICE',

  // Header & Company Branding
  showLogo: true,
  logoWidth: 140,
  showCompanyNameEn: true,
  showCompanyNameAr: true,
  showCompanyAddress: true,
  showCompanyPhone: true,
  showCompanyEmail: true,
  showCompanyWebsite: true,
  showCompanyTaxId: true,

  // Customer Section
  showCustomerName: true,
  showCustomerAddress: true,
  showCustomerPhone: true,
  showCustomerEmail: true,
  showCustomerTaxId: true,

  // Document Info
  showDocNumber: true,
  showDocDate: true,
  showDueDate: true,
  showSalesperson: true,
  salespersonLabel: 'Salesperson',
  salespersonPosition: 'header', // 'header' | 'customer' | 'bottom'
  showSalespersonEmail: false,
  showSalespersonPhone: false,
  showPaymentTerms: true,
  showBarcode: true,

  // Table Columns
  columns: {
    srNo: true,
    sku: true,
    barcode: false,
    description: true,
    unit: true,
    warranty: true,
    serialNo: true,
    quantity: true,
    unitPrice: true,
    discount: true,
    taxRate: true,
    taxAmount: false,
    total: true,
  },

  // Column Custom Labels
  columnLabels: {
    srNo: '#',
    sku: 'Item Code',
    barcode: 'Barcode',
    description: 'Description',
    unit: 'Unit',
    quantity: 'Qty',
    unitPrice: 'Price',
    discount: 'Disc.',
    taxRate: 'VAT %',
    total: 'Total',
  },

  // Totals & Summary
  showSubtotal: true,
  showTotalDiscount: true,
  showTaxSummary: true,
  showAmountInWords: true,

  // Banking & Payment
  showBankDetails: true,
  bankDetails: {
    bankName: '',
    accountName: '',
    accountNumber: '',
    iban: '',
    swift: '',
    branch: '',
  },

  // Notes, Terms & Signatures
  invoiceTerms: '1. Goods once sold cannot be returned without original receipt.\n2. Warranty covers manufacturing defects only as per policy.',
  quotationTerms: '1. This price quotation is valid for 30 days from date of issue.\n2. Payment terms: 50% advance, balance upon delivery/installation.',
  defaultNotes: 'Thank you for your business!',
  showSignatureBox: true,
  signatureLabel: 'Authorized Signature & Stamp',
  showCustomerSignature: false,
  customerSignatureLabel: 'Customer Acceptance',
};

export function parseInvoiceDesignSettings(rawSettings) {
  if (!rawSettings) return { ...DEFAULT_INVOICE_DESIGN };
  let parsed = {};
  if (typeof rawSettings === 'string') {
    try {
      parsed = JSON.parse(rawSettings);
    } catch {
      parsed = {};
    }
  } else if (typeof rawSettings === 'object') {
    parsed = rawSettings;
  }

  return {
    ...DEFAULT_INVOICE_DESIGN,
    ...parsed,
    columns: {
      ...DEFAULT_INVOICE_DESIGN.columns,
      ...(parsed.columns || {}),
    },
    columnLabels: {
      ...DEFAULT_INVOICE_DESIGN.columnLabels,
      ...(parsed.columnLabels || {}),
    },
    bankDetails: {
      ...DEFAULT_INVOICE_DESIGN.bankDetails,
      ...(parsed.bankDetails || {}),
    },
  };
}
